<template>
	<AudioLibraryShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		:id-key="idKey"
		@select="$emit('select')"
	/>
</template>

<script>
	import AudioLibraryShell from '../shared/AudioLibraryShell.vue';
	import { mediaBlockEmits, mediaBlockProps } from '../shared/mediaBlockProps.js';

	export default {
		name: 'GBlockAudioLibrary',
		components: { AudioLibraryShell },
		props: mediaBlockProps,
		emits: mediaBlockEmits,
	};
</script>
